import React, { useState } from 'react';
import { DocumentTextIcon, HandThumbUpIcon, HandThumbDownIcon, ChatBubbleLeftRightIcon, LinkIcon } from '@heroicons/react/24/outline';

const PlayerSummaryDisplay = ({ summaryData, isMobile }) => {
    const [activeTab, setActiveTab] = useState('overall'); // 'overall', 'notes', 'caseFor', 'caseAgainst'

    if (!summaryData) {
        return (
            <div className="p-4 text-center text-sm text-base-content/70 bg-base-100 rounded-lg shadow h-[300px] md:h-[300px] flex flex-col justify-center items-center">
                <ChatBubbleLeftRightIcon className="w-8 h-8 mx-auto mb-2 text-base-content/50" />
                No summary available.
            </div>
        );
    }

    const { summary_o, summary_g, case_for, case_against, case_for_source, case_against_source } = summaryData;

    const sections = {
        overall: { title: "Summary", content: summary_o, Icon: DocumentTextIcon },
        notes: { title: "Notes", content: summary_g, Icon: DocumentTextIcon },
        caseFor: { title: "Case For", content: case_for, source: case_for_source, Icon: HandThumbUpIcon },
        caseAgainst: { title: "Case Against", content: case_against, source: case_against_source, Icon: HandThumbDownIcon },
    };

    const availableSections = Object.keys(sections).filter(key => sections[key].content && sections[key].content.trim() !== "");

    if (availableSections.length === 0) {
        return (
            <div className="p-4 text-center text-sm text-base-content/70 bg-base-100 rounded-lg shadow h-[300px] md:h-[300px] flex flex-col justify-center items-center">
                <ChatBubbleLeftRightIcon className="w-8 h-8 mx-auto mb-2 text-base-content/50" />
                Summary data is empty.
            </div>
        );
    }
    
    if (!availableSections.includes(activeTab) && availableSections.length > 0) {
        setActiveTab(availableSections[0]);
        return null; 
    }

    const CurrentIcon = sections[activeTab]?.Icon;

    return (
        <div className="flex flex-col bg-base-100 rounded-lg shadow h-[300px] md:h-[300px]">
            <div className="flex px-1 pt-0.5 shrink-0">
                {availableSections.map((key) => {
                    const section = sections[key];
                    return (
                        <button
                            key={key}
                            onClick={() => setActiveTab(key)}
                            title={section.title}
                            className={`flex items-center justify-center py-1.5 text-xs font-medium rounded-t-md transition-colors duration-150 focus:outline-none 
                                        ${isMobile ? 'px-2 flex-1' : 'px-3'}
                                        ${activeTab === key 
                                            ? 'bg-accent/10 text-accent border-b-2 border-accent'
                                            : 'text-base-content/70 hover:bg-base-200/70 hover:text-base-content'}
                                        mr-0.5 last:mr-0`}
                        >
                            <section.Icon className={`w-4 h-4 ${!isMobile && section.title ? 'mr-1.5' : ''} flex-shrink-0`} />
                            {!isMobile && <span className="whitespace-nowrap">{section.title}</span>}
                        </button>
                    );
                })}
            </div>
            <div className="py-2 px-3 flex-grow overflow-y-auto scrollbar-thin scrollbar-thumb-base-content/30 scrollbar-track-base-300/50 min-h-0 ">
                {sections[activeTab]?.content ? (
                    <div className="text-xs text-base-content/90 whitespace-pre-wrap leading-relaxed">
                        {sections[activeTab].content}
                        {(activeTab === 'caseFor' || activeTab === 'caseAgainst') && sections[activeTab].source && (
                            <div className="mt-2 pt-1.5 border-t border-base-content/10">
                                <p className="text-2xs text-base-content/70 flex items-center">
                                    <LinkIcon className="w-3 h-3 mr-1 flex-shrink-0 text-base-content/50" />
                                    Source: {sections[activeTab].source}
                                </p>
                            </div>
                        )}
                    </div>
                ) : (
                     <p className="text-sm text-base-content/60 text-center py-4">No content for this section.</p>
                )}
            </div>
        </div>
    );
};

export default PlayerSummaryDisplay; 